import styled from 'styled-components';
import { CardS } from '../../GlobalStyles';
import { RGBA_COLORS } from '../../utils/colors';
import { CHAT_WIDTH } from '../../utils/consts';

export const WrapperS = styled(CardS)`
  min-width: ${CHAT_WIDTH};
  max-width: ${CHAT_WIDTH};
  height: calc(100% - 20px);
  margin: 10px 10px 0 0;
  position: relative;
`;

export const MessagesWrapperS = styled.div`
  flex: 1;
  overflow: auto;
`;

export const InputWrapperS = styled.div`
  width: 100%;
  textarea {
    width: 100%;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 2px solid transparent;
    background: rgba(0, 0, 0, 0.05);
    padding: 10px;
    min-height: 40px;

    &:focus {
      outline: 0;
      border-color: #1a82c5;
    }
  }
`;

export const FootersWrapperS = styled.div`
  display: flex;
  align-items: center;
`;

export const BtnS = styled.button`
  font-size: 22px;
`;

export const SmilesWrapperS = styled.div`
  display: flex;
  position: absolute;
  flex-wrap: wrap;
  background: white;
  z-index: 9;
  border-radius: 8px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  left: 27%;
  transform: translateX(-50%);
  min-width: 200px;
  max-width: 200px;
  bottom: 100%;
  transition: 0.2s;
  img {
    width: 80%;
  }
  & > * {
    height: 30px;
    width: 30px;
    line-height: 0;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    margin: 5px;
    border: 1px solid transparent;
    cursor: pointer;
    border-radius: 5px;

    &:hover {
      border: 1px solid ${RGBA_COLORS.getAccent(0.2)};
    }
    &:active {
      border: 1px solid ${RGBA_COLORS.getAccent(0.7)};
    }
  }
`;

export const ChatField = styled.div`
  max-height: 200px;
  overflow: auto;
  min-height: 40px;
  width: 100%;
  [contentEditable='true']:empty:not(:focus):before {
    content: attr(data-text);
  }
  margin-bottom: 5px;
`;

export const ChatInput = styled.div`
  border: none;
  font-size: 14px;
  outline: none;
  width: 100%;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 2px solid transparent;
  background: rgba(0, 0, 0, 0.05);
  padding: 10px;
  min-height: 40px;
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;

  &:focus {
    outline: 0;
    border-color: #1a82c5;
  }
  div {
    display: inline-block;
  }

  &:before {
    color: rgba(34, 47, 62, 0.7);
  }
`;

export const WrappTool = styled.div`
  position: relative;
  flex: 1 1 0%;
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const Hint = styled.div<{ isError?: boolean }>`
  font-size: 14px;
  color: rgba(34, 47, 62, 0.7);
  ${({ isError }) => (isError ? 'color: red;' : '')}
`;

export const Tabs = styled.div`
  margin-bottom: 10px;
  display: flex;
  background: rgba(0, 0, 0, 0.05);
  color: rgba(50, 51, 50, 0.8);
`;

export const Tab = styled.div<{ active?: boolean; last?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 6px 10px;
  cursor: pointer;
  ${({ active, last }) =>
    active
      ? `
      font-weight: bold;
      box-shadow: inset 0px -2px rgb(26 130 197), 
        inset 0px 2px rgb(26 130 197), 
        inset -2px 0px rgb(26 130 197), 
        inset 2px 0px rgb(26 130 197);`
      : !last && `box-shadow: inset -1px 0px rgba(50, 51, 50, 0.22);`}
`;
export const NameS = styled.span`
  width: 40px;
  height: 100%;
  margin-right: 7px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  font-size: 12px;
`;
